import { twMerge } from "tailwind-merge";
import { IconsProps } from ".";

export const Wheelchair = ({
  className = "text-primary",
  viewBox = "0 0 24 24",
  width = 24,
  height = 24,
  onClick,
}: IconsProps) => (
  <svg
    className={twMerge("cursor-pointer", className)}
    viewBox={viewBox}
    width={`${width}px`}
    height={`${height}px`}
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <title>Wheelchair Accessible</title>
    <path
      d="M2.59771 2.93204C2.59771 1.67385 3.60653 0.665039 4.86471 0.665039C6.1229 0.665039 7.13171 1.67385 7.13171 2.93204C7.13171 4.19022 6.1229 5.19904 4.86471 5.19904C3.60653 5.19904 2.59771 4.19022 2.59771 2.93204ZM8.83196 10.8099V8.59954C8.83196 7.35269 7.81181 6.33254 6.56496 6.33254H3.16446C1.91761 6.33254 0.897461 7.35269 0.897461 8.59954V15.4005H3.16446V23.335H7.13171V23.2104C5.72617 21.7821 4.86471 19.8212 4.86471 17.6675C4.86471 14.7431 6.46295 12.1814 8.83196 10.8099ZM16.1997 17.6675C16.1997 19.5378 14.6695 21.068 12.7992 21.068C10.9289 21.068 9.39871 19.5378 9.39871 17.6675C9.39871 16.4094 10.0901 15.3325 11.099 14.7431V12.2947C8.80929 13.0202 7.13171 15.1398 7.13171 17.6675C7.13171 20.796 9.67075 23.335 12.7992 23.335C15.9277 23.335 18.4667 20.796 18.4667 17.6675H16.1997ZM19.6456 14.267H14.4995V7.46604H12.2325V16.534H18.4214L21.2211 20.7393L23.1027 19.4811L19.6456 14.267Z"
      fill="currentColor"
    />
  </svg>
);
